// extracted by mini-css-extract-plugin
export default {"title":"styles_title__8gAS8","h1":"styles_h1__+qgeB","h2":"styles_h2__1Hmqo"};